import cloneDeep from 'lodash/cloneDeep';

import { RECEIVE_SEARCH_RESULTS } from '../search-filter/search-filter-actions';

import { getInitialSearchObjWithTrackingData, parseSupportData, getInitialSupportSearchObjFromQueryString } from './util';
import { updateComponent } from '../page/page-actions';
import { getSearchAPIClientFromState } from './useSearchEndpoint';
import { SupportAPI } from '../core/src/support-client';
import { Helpers } from '../core/src/helpers';


const supportApi = new SupportAPI();

/**
 * Used to trigger search in SRP from outside of the hawksearch HOC
 */
export const setInitialSearchIdentifier = initialSearchId => ({
    type: RECEIVE_SEARCH_RESULTS,
    searchKey: 'hawksearch',
    initialSearchId,
});

/**
 *
 * @param {*} results - new sets of hawksearch results
 * @param {*} options - object containing:
 *                          1. isPaginating - indicates if the result is paginating, meaning the results must be appended to current results
 *                          2. type - either blogs or products, default is products
 */
export const updateHawksearchResultsComponent = options => (state, components) => {
    const { isPaginating, query, currentSearch } = options || {};
    let type = isPaginating
        ? state && state.components && state.components.hawksearchResults && state.components.hawksearchResults.type
        : options && options.type;
    const currentResults = state?.components?.hawksearchResults?.[type];
    const { Results } = currentResults || {};
    const newState = cloneDeep(state);
    if (!type) return state;
    try {
        const newHawksearchResults = components && components.hawksearchResults;
        const newResults = newHawksearchResults && newHawksearchResults.Results;
        newState.components = newState.components || {};
        newState.components.hawksearchResults = newState.components.hawksearchResults || {};
        newState.components.hawksearchResults[type] = components.hawksearchResults;
        newState.components.hawksearchResults[type].currentSearch = currentSearch;
        newState.components.hawksearchResults[type].query = query;
        newState.components.hawksearchResults.query = query;
        newState.components.hawksearchResults.type = type;
        if (isPaginating) {
            newState.components.hawksearchResults[type].Results = Results.concat(newResults);
            newState.components.hawksearchResults.query = state.components.hawksearchResults.query;
            newState.components.hawksearchResults[type].query = state.components.hawksearchResults[type].query;
        }
    } catch (e) {}
    return newState;
};

export const updateSupportResultsComponent = options => (state, components) => {
    const newState = cloneDeep(state);
    try{
        const { query, currentSearch } = options || {};
        const newSupportResults = components && components.supportResults;
        newState.components = newState.components || {};
        newState.components.supportResults = newSupportResults || {};
        newState.components.supportResults.query = query;
        newState.components.supportResults.currentSearch = currentSearch;
    }catch(e){}

    return newState;
}

export const updateHawksearchComponent = (dispatch, components, options) =>
    dispatch(updateComponent(components, updateHawksearchResultsComponent(options)));

export const fetchHawksearchResultsAndUpdateComponent = (queryObj, options, dispatch, hawksearchAPI) =>
    hawksearchAPI.search(queryObj).then(resp => {
        const { data } = resp || {};
        const components = {
            hawksearchResults: data,
        };
        dispatch(
            updateComponent(components, updateHawksearchResultsComponent({ ...options, currentSearch: queryObj }))
        );
    });

export const NUM_SUPPORT_RESULTS_PER_PAGE = 24;
export const fetchSupportResults = Helpers.memoize((searchKey) => supportApi.typeahead( searchKey, NUM_SUPPORT_RESULTS_PER_PAGE ));

export const fetchSupportResultsAndUpdateComponent = (queryObj, options, dispatch) => {
    const searchKey = queryObj && queryObj.q;
    const currentSearch = {
        currentSearch: queryObj
    }
    const updatedState = updateSupportResultsComponent({ ...options, currentSearch })
    return fetchSupportResults(searchKey).then(resp => {
        const supportPages = parseSupportData(resp);
        const components = {
            supportResults: {
                supportPages,
                searchKey
            }
        }
        dispatch(
            updateComponent(components, updatedState)
        );
    }).catch(fetchError => {
        const components = {
            supportResults: {
                searchKey,
                fetchError
            }
        }
        dispatch(
            updateComponent(components, updatedState)
        );
    })
}

export const fetchHawksearchResults = (queryObj, options) => (dispatch, getState) => {
    const hawksearchAPI = getSearchAPIClientFromState('search', getState());
    fetchHawksearchResultsAndUpdateComponent(queryObj, options, dispatch, hawksearchAPI);
};

/**
 * Makes Hawksearch Search API using query string. Used only when:
 * - search page mounts the first time
 * - switching tabs
 */
export const fetchHawksearchResultsUsingUrl = options => (dispatch, getState) => {
    const hawksearchAPI = getSearchAPIClientFromState('search', getState());
    const queryObj = getInitialSearchObjWithTrackingData(getState());
    fetchHawksearchResultsAndUpdateComponent(queryObj, options, dispatch, hawksearchAPI);
};

/**
 * Makes Support API requests using query string. Used only when:
 * - search page mounts the first time on the Support tab
 * - switching tabs
 */
export const fetchSupportResultsUsingUrl = options => (dispatch, getState) => {
    // const hawksearchAPI = getSearchAPIClientFromState('search', getState());
    // const queryObj = getInitialSearchObjWithTrackingData();
    const queryObj = getInitialSupportSearchObjFromQueryString();
    // const searchObj = getInitialSearchObjFromQueryString();
    fetchSupportResultsAndUpdateComponent(queryObj, options, dispatch);
};
